export class ForecastGraph {

    totalSignalCount: number;
    availableSignalCount: number;
    dataAquisitionTimestamp: number;
    ratedPower: number;
    hours: number;
    history: any;
    alarms: any;


    static mapDataMW(level: any) {
        return new ForecastGraph({
          history: {
            timestamps: this.generateTimestamps(
              level.dataSeries.WTUR1_MW_avg_mag_f.startingTS,
              level.dataSeries.WTUR1_MW_avg_mag_f.lastTS,
              level.dataSeries.WTUR1_MW_avg_mag_f.intervalTS
            ),
            actualPower: level.dataSeries.WTUR1_MW_avg_mag_f.data,

          },
        });
      }
      static mapDatakW(level: any) {
        return new ForecastGraph({
          history: {
            timestamps: this.generateTimestamps(
              level.dataSeries.WTUR1_kW_avg_mag_f.startingTS,
              level.dataSeries.WTUR1_kW_avg_mag_f.lastTS,
              level.dataSeries.WTUR1_kW_avg_mag_f.intervalTS
            ),
            actualPower: level.dataSeries.WTUR1_kW_avg_mag_f.data,

          },
        });
      }








  static generateTimestamps(startingTS: number, lastTS: number, intervalTS: number): number[] {
    const timestamps = [];
    if (startingTS !== lastTS) {
      for (let i = startingTS; i <= lastTS; i += intervalTS) {
        timestamps.push(i);
      }
    }
    return timestamps;
  }

  constructor(init: Partial<ForecastGraph>) {
    Object.assign(this, init);
  }
}
